import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import * as triplinkService from '../../../utils/triplinkService';
import { finishStripeCheckout } from '../../thunks/checkout';

// Thunks

export const createStripeCheckoutSession = createAsyncThunk(
  'checkout/createStripeCheckoutSession',
  async (params: {price_keys: string[], qty: number, trial: boolean}, { dispatch, getState }) => {
    const state: RootState = (getState() as RootState);
    const accessToken = state.accessToken.body;//FIXME need to ensure this token is not expired
    if (!accessToken) {
      throw new Error('cannot createStripeCheckoutSession without access');
    }
    const result = await triplinkService.createStripeCheckoutSession(accessToken, params);
    return result;
  }
)

// Define checkout state

export interface CheckoutState {
  stripeSession: object | null;
  selectedPriceKeys: string[] | null;
  selectedQty: number;
}

const initialState: CheckoutState = {
  stripeSession: null,
  selectedPriceKeys: null,
  selectedQty: 1,
};

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(createStripeCheckoutSession.pending, (state, action) => {
        state.stripeSession = null;
        state.selectedQty = action.meta.arg.qty;
        state.selectedPriceKeys = action.meta.arg.price_keys;
      })
      .addCase(createStripeCheckoutSession.fulfilled, (state, action) => {
        state.stripeSession = action.payload;
      })
      .addCase(createStripeCheckoutSession.rejected, (state, action) => {
        //pass
      })
      .addCase(finishStripeCheckout.fulfilled, (state, action) => {
        state.stripeSession = null;
        state.selectedQty = 0;
        state.selectedPriceKeys = null;
      })
  },
});

//export const { 
//} = checkoutSlice.actions
export const selectCheckout = (state: RootState) => state.checkout;
export default checkoutSlice.reducer;
